//
// Copyright (c) 2011-2024 by Curalate, Inc.
//

export const UIA_RIGHTS_REQUEST = {
  GRAPH_RIGHTS_CAPABILITY: 'GRAPH_RIGHTS_CAPABILITY',
  BYPASS_RIGHTS_REQUEST: 'BYPASS_RIGHTS_REQUEST',
  SET_CUSTOM_RIGHTS_REQUEST: 'SET_CUSTOM_RIGHTS_REQUEST',
  GRAPH_RIGHTS_REQUEST_STARTED: 'GRAPH_RIGHTS_REQUEST_STARTED',
  GRAPH_RIGHTS_REQUEST_ENDED: 'GRAPH_RIGHTS_REQUEST_ENDED',
  RIGHTS_REQUEST_STARTED: 'RIGHTS_REQUEST_STARTED',
  RIGHTS_REQUEST_ENDED: 'RIGHTS_REQUEST_ENDED',
  RIGHTS_STATUS_CHANGED: 'RIGHTS_STATUS_CHANGED',
  SKIP_RIGHTS_REQUEST_STARTED: 'SKIP_RIGHTS_REQUEST_STARTED',
  SKIP_RIGHTS_REQUEST_ENDED: 'SKIP_RIGHTS_REQUEST_ENDED',
};
